// InstallPromptContext.js
import React, { createContext, useState, useEffect } from "react";

export const InstallPromptContext = createContext();

export const InstallPromptProvider = ({ children }) => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstall, setShowInstall] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShowInstall(true);
        };

        window.addEventListener("beforeinstallprompt", handler);

        return () => {
            window.removeEventListener("beforeinstallprompt", handler);
        };
    }, []);

    return (
        <InstallPromptContext.Provider
            value={{ deferredPrompt, setDeferredPrompt, showInstall, setShowInstall }}
        >
            {children}
        </InstallPromptContext.Provider>
    );
};
